<template>
  <div class="node-container">
    <div class="input-group search left">
      <input
        type="text"
        class="form-control"
        placeholder="Kategori Adı Ara"
        v-model="search"
        v-readonly
      >
      <span class="add-on">
        <img :src="`${$root.cdnUrl}assets/icon-search.png`">
      </span>
    </div>
    <ul class="node">
      <li
        v-if="items.Name"
        class="back"
        @click="onBack"
      >
        <span>
          <img
            :src="`${$root.cdnUrl}assets/icon-arrow-left-gray.svg`"
          >
          {{ items.Name }}
        </span>
      </li>
      <li
        v-for="(item, k) in getItems"
        :key="k"
        @click="onSelect(item)"
      >
        <span :class="{disabled: item.isClosed}">
          {{ item.Name }}

          <img
            v-if="item.Nodes"
            :src="`${$root.cdnUrl}assets/icon-arrow-right.svg`"
          >
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Node',
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      search: '',
    };
  },
  computed: {
    getItems () {
      if (this.search.trim() === '') {
        return this.items.Nodes;
      }
      return this.items.Nodes.filter(item => item.Name.toLowerCase().search(this.search.trim().toLowerCase()) > -1);
    },
  },
  methods: {
    onSelect (category) {
      if (category.isClosed) return;
      this.$emit('onSelect', category);
    },
    onBack () {
      this.$emit('onBack');
    },
  },
};
</script>

<style lang="scss" scoped>
  .node-container {
    min-width: 100%;
    flex: 1;
    .input-group {
      margin:0 15px 20px;
    }

    .node {
      border-top: 1px solid #DEE0EB;
      list-style: none;
      margin: 0;
      padding: 0;
      overflow: auto;
      max-height: 400px;
      li {
        position: relative;
        border-bottom: 1px solid #DEE0EB;
        span {
          display: block;
          padding: 15px;
          padding-right: 35px;
          position: relative;

          &.disabled {
            cursor: not-allowed;
            color: #C4C4C4;
          }

          img {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
          }
        }

        &.back {
          position: sticky;
          top: 0;
          background-color: #ffffff;
          z-index: 1;

          span {
            padding: 15px;
            padding-left: 35px;
            color: rgb(110, 119, 135);
          }
          img {
            position: absolute;
            top: 50%;
            left: 15px;
            right: initial;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

</style>
